import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import Landing from './pages/Landing';
import Admin from './pages/Admin';
import './App.css';

function App() {
  // Track unique visit on app load
  useEffect(() => {
    const trackVisit = async () => {
      try {
        // Get or create session ID
        let sessionId = sessionStorage.getItem('vida_mujer_session');
        if (!sessionId) {
          sessionId = `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
          sessionStorage.setItem('vida_mujer_session', sessionId);
        }
        
        const API_URL = process.env.REACT_APP_BACKEND_URL;
        await fetch(`${API_URL}/api/analytics/track-visit`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ session_id: sessionId })
        });
      } catch (error) {
        console.error('Error tracking visit:', error);
      }
    };
    
    trackVisit();
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      <Toaster 
        position="top-right" 
        toastOptions={{
          style: {
            background: '#0F2B5B',
            color: 'white',
            borderRadius: '12px'
          }
        }}
      />
    </div>
  );
}

export default App;
